import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";
import { write, writeFile, utils } from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { exportExcelState, exportExcelDeliveryHold } from "../../actions/studensts";

export default function Deliver() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = useLocation().pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(
      () => dispatch(getType("deliver", state, search)),
      500
    );
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  const handleExport = async () => {
    try {
      const { data } = await exportExcelState("deliver_onsite");
      const stateFilter = data.data;
      const fields = [
        "id",
        "passport_number",
        "full_name",
        "test_center_name",
        "phone",
        "gender",
        "category",
        "email",
        "act1_copy_number",
        "act2_copy_number",
        "submit_date",
        "request_edit_user",
        "request_edit",
        "moe_validation_user",
        "moe_pending_date",
        "moe_pending_user",
        "total_main",
        "another_total_main",
        "amount_outside",
      ];
      const filteredData = stateFilter.map((item) => {
        const filteredItem = {};
        fields.forEach((field) => {
          filteredItem[field] = item[field];
        });
        return filteredItem;
      });
      const workSheet = utils.json_to_sheet(filteredData);
      const workBook = utils.book_new();
      utils.book_append_sheet(workBook, workSheet, "deliver_onsite");
      write(workBook, { bookType: "xlsx", type: "buffer" });
      write(workBook, { bookType: "xlsx", type: "binary" });
      writeFile(workBook, "deliver_onsite.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  const handleExportDeliveryHold = async () => {
    try {
      const { data } = await exportExcelDeliveryHold();
      const students = data.data;

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "AATC System";
      workbook.created = new Date();
      const sheet = workbook.addWorksheet("Delivery Hold Report");

      // --- Title Row ---
      sheet.mergeCells("A1:H1");
      const titleCell = sheet.getCell("A1");
      titleCell.value = "Delivery Hold Students Report";
      titleCell.font = { name: "Arial", size: 16, bold: true, color: { argb: "FFFFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1F4E79" } };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(1).height = 35;

      // --- Total Count Row ---
      sheet.mergeCells("A2:H2");
      const countCell = sheet.getCell("A2");
      countCell.value = `Total Students: ${students.length}`;
      countCell.font = { name: "Arial", size: 13, bold: true, color: { argb: "FF1F4E79" } };
      countCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD6E4F0" } };
      countCell.alignment = { horizontal: "center", vertical: "middle" };
      sheet.getRow(2).height = 28;

      // --- Empty spacer row ---
      sheet.getRow(3).height = 8;

      // --- Header Row (row 4) ---
      const headers = [
        "National ID",
        "Passport Number",
        "Full Name",
        "Phone Number",
        "Reason",
        "Comment",
        "Delivery Hold Date",
        "Commented By",
      ];
      const headerRow = sheet.getRow(4);
      headerRow.values = headers;
      headerRow.height = 26;
      headerRow.eachCell((cell) => {
        cell.font = { name: "Arial", size: 11, bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF2E75B6" } };
        cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        cell.border = {
          top: { style: "thin", color: { argb: "FF1F4E79" } },
          bottom: { style: "thin", color: { argb: "FF1F4E79" } },
          left: { style: "thin", color: { argb: "FF1F4E79" } },
          right: { style: "thin", color: { argb: "FF1F4E79" } },
        };
      });

      // --- Data Rows ---
      students.forEach((s, idx) => {
        const row = sheet.getRow(5 + idx);
        row.values = [
          s["National ID"],
          s["Passport Number"],
          s["Full Name"],
          s["Phone Number"],
          s["Reason"],
          s["Comment"],
          s["Delivery Hold Date"],
          s["Commented By"],
        ];
        const isEven = idx % 2 === 0;
        row.eachCell((cell) => {
          cell.font = { name: "Arial", size: 10 };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: isEven ? "FFF2F7FB" : "FFFFFFFF" },
          };
          cell.border = {
            top: { style: "thin", color: { argb: "FFB4C6E7" } },
            bottom: { style: "thin", color: { argb: "FFB4C6E7" } },
            left: { style: "thin", color: { argb: "FFB4C6E7" } },
            right: { style: "thin", color: { argb: "FFB4C6E7" } },
          };
        });
      });

      // --- Column Widths ---
      sheet.columns = [
        { width: 20 },  // National ID
        { width: 20 },  // Passport Number
        { width: 30 },  // Full Name
        { width: 18 },  // Phone Number
        { width: 28 },  // Reason
        { width: 35 },  // Comment
        { width: 22 },  // Delivery Hold Date
        { width: 22 },  // Commented By
      ];

      // --- Generate & Download ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "delivery_hold_report.xlsx");
    } catch (error) {
      console.error("Export to Excel failed:", error);
    }
  };

  return (
    <div>
      {user !== "user" && user !== "admin" ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <div className="flex items-center justify-between px-6 pt-4">
            <h1 className="text-2xl pt-0 pb-5 text-white">
              {studentType === "deliver_onsite"
                ? "Delivery Onsite"
                : studentType === "aramex"
                ? "Aramex"
                : studentType === "delivery_hold"
                ? "Delivery Hold"
                : ""}
            </h1>
            {studentType === "deliver_onsite" && (
              <button
                onClick={handleExport}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
              >
                Export to Excel
              </button>
            )}
            {studentType === "delivery_hold" && (
              <button
                onClick={handleExportDeliveryHold}
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
              >
                Export to Excel
              </button>
            )}
          </div>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
              flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                setSearch={(val) => {
                  setSearch(val);
                  setHasSearched(true);
                }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "deliver_onsite":
      return "deliver_onsite";
    case "aramex":
      return "aramex";
    case "delivery_hold":
      return "delivery_hold";
    default:
      return "deliver_onsite";
  }
}
